module.exports = __webpack_public_path__ + "img/18.108.A.a23d4c2a.png";